import React, { forwardRef, useEffect, useState } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";

export const CheckBox = forwardRef(({ title, className, checked, setChecked, defaultValue = false, required, small, name }, ref) => {
    const isControlled = checked !== undefined;
    const [localCheck, setLocalCheck] = useState(!isControlled ? defaultValue : checked);
    useEffect(() => {
        if (checked !== undefined) {
            setLocalCheck(checked);
        }
    }, [checked]);
    return (
        <label className={`flex items-center cursor-pointer ${className}`}>
            <input
                type="checkbox"
                className={"hidden"}
                ref={ref}
                required={required}
                checked={localCheck}
                name={name}
                onChange={(e) => {
                    if (isControlled && !!setChecked) {
                        setChecked(e.target.checked);
                    } else {
                        setLocalCheck(e.target.checked);
                    }
                }}
            />

            <div className={`flex justify-center items-center border-2 border-gray-600 rounded ${small ? "w-4 h-4" : "w-6 h-6"}`}>
                {localCheck && <CheckIcon className={`text-gray-900 ${small ? "w-3 h-3" : "w-5 h-5"}`} />}
            </div>

            <div className={"ml-2 text-gray-900"}>{title}</div>
        </label>
    );
});
//# sourceMappingURL=checkBox.jsx.map
